export const PAYMENT_TYPE_CODE = {
  BACS_DIRECT_DEBIT: 'bacsDirectDebit',
}
